import React, { useEffect } from 'react';

/**
 * SEO Komponente zur dynamischen Verwaltung von Seitentiteln und Meta-Beschreibungen
 */
const SEO = ({ title, description, noindex = false }) => {
  useEffect(() => {
    // Titel setzen
    const baseTitle = "Nordblick Recruiting";
    document.title = title ? `${title} | ${baseTitle}` : `${baseTitle} - Private Arbeitsvermittlung & AVGS`;

    // Meta-Beschreibung setzen
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || "Nordblick Recruiting: Ihre Experten für private Arbeitsvermittlung mit AVGS in Hamburg & Norddeutschland.");
    }

    // Robots Meta-Tag (für Bewerberprofile wichtig)
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!metaRobots) {
        metaRobots = document.createElement('meta');
        metaRobots.setAttribute('name', 'robots');
        document.head.appendChild(metaRobots);
      }
      metaRobots.setAttribute('content', 'noindex, nofollow');
    } else if (metaRobots) {
      metaRobots.setAttribute('content', 'index, follow');
    }
  }, [title, description, noindex]);

  return null;
};

export default SEO;